<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6">
          <v-toolbar color="secondary" dark shaped>
            <h3 class="title">Selecione a prefeitura e secretaria:</h3>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <Date
                    @dateValue="[(filter.startDate = $event)]"
                    label="Data Inicial"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <Date
                    @dateValue="[(filter.endDate = $event)]"
                    label="Data Final"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    v-model="filter.prefecture_id"
                    label="Prefeitura"
                    :items="prefectures"
                    item-text="prefecture_social_name"
                    item-value="prefecture_id"
                    clearable
                    @change="[getSecretariats(), getVehicles(), getProviders()]"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    :items="providers"
                    label="Participante:"
                    v-model="filter.provider_id"
                    item-value="provider_id"
                    item-text="provider_name"
                    clearable
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    v-model="filter.sec_id"
                    label="Secretaria"
                    :items="secretariats"
                    item-text="sec_name"
                    item-value="sec_id"
                    clearable
                    @change="getVehicles"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <br />
          <v-footer absolute rounded>
            <v-btn text :loading="loader"></v-btn>
            <v-spacer />
            <v-btn
              color="secondary"
              class="mr-2"
              text
              @click="getData"
              :disabled="
                filter.startDate &&
                filter.endDate &&
                filter.prefecture_id &&
                filter.provider_id
                  ? false
                  : true
              "
              >BUSCAR</v-btn
            >
          </v-footer>
        </v-card>
      </v-col>

      <v-col>
        <v-card class="mb-6">
          <v-toolbar color="secondary" dark shaped>
            <h3 class="title">
              Selecione os abastecimentos para o desbloqueio:
            </h3>
            <v-spacer />
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="showSearch = !showSearch"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Pesquisar</span>
            </v-tooltip>
            <v-footer absolute color="primary" dark v-if="showSearch">
              <v-text-field
                class="search-field"
                v-model="search"
                color="#fff"
                placeholder="pesquisar"
                prepend-inner-icon="mdi-magnify"
                append-outer-icon="mdi-close"
                @click:append-outer="showSearch = !showSearch"
              />
            </v-footer>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-data-table
                show-select
                v-model="selectedSupplies"
                :headers="headers"
                :items="dataSupplies"
                :search="search"
                item-key="supply_id"
              >
                <template v-slot:item.supply_billed="{ item }">
                  <span>{{ item.supply_billed ? "SIM" : "NÃO" }}</span>
                </template>
                <template v-slot:item.supply_ajusted="{ item }">
                  <span>{{ item.supply_ajusted ? "SIM" : "NÃO" }}</span>
                </template>
                <template v-slot:item.datehour="{ item }">
                  <span>{{ convertDateTime(item.datehour) }}</span>
                </template>
                <template v-slot:item.supply_liters_stocked="{ item }">
                  <span>{{
                    item.supply_liters_stocked
                      ? realMaskII(item.supply_liters_stocked)
                      : 0
                  }}</span>
                </template>
                <template v-slot:item.item_billing_price="{ item }">
                  <span>{{
                    item.supply_bidding_price
                      ? realMaskII(item.supply_bidding_price)
                      : 0
                  }}</span>
                </template>
                <template v-slot:item.total_billing_price="{ item }">
                  <span>{{
                    item.supply_bidding_price && item.supply_liters_stocked
                      ? realMask(
                          (
                            item.supply_bidding_price *
                            item.supply_liters_stocked
                          ).toFixed(2)
                        )
                      : 0
                  }}</span>
                </template>
                <template v-slot:item.supply_price_day="{ item }">
                  <span>{{
                    item.supply_price_day
                      ? realMaskII(item.supply_price_day)
                      : 0
                  }}</span>
                </template>
                <template v-slot:item.supply_value="{ item }">
                  <span>{{
                    item.supply_value
                      ? realMask(item.supply_value.toFixed(2))
                      : 0
                  }}</span>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
          <v-footer>
            <v-label
              >Total Dia:
              {{
                totals.day_value ? realMask(totals.day_value.toFixed(2)) : 0
              }}</v-label
            >
            <v-spacer />
            <v-label
              >Total Liçitado:
              {{
                totals.bidding_total
                  ? realMask(totals.bidding_total.toFixed(2))
                  : 0
              }}</v-label
            >
            <v-spacer />
            <v-btn text :loading="loader"></v-btn>
            <v-btn
              depressed
              @click="updateSupplies"
              :disabled="
                !filter.vehicle_id || selectedSupplies.length == 0
                  ? true
                  : false
              "
              >DESBLOQUEAR ABASTECIMENTOS</v-btn
            >
          </v-footer>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <v-card>
          <v-toolbar color="secondary" dark shaped>
            <h3 class="title">Resumo do Veículo</h3>
          </v-toolbar>
          <v-row style="padding: 10px">
            <v-col cols="12" sm="12" md="6">
              <v-card class="mb-6" outlined>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                          v-model="filter.vehicle_id"
                          label="Veículo"
                          :items="vehicles"
                          clearable
                          @change="getVehicleData()"
                          item-text="vehicle_board"
                          item-value="vehicle_id"
                        >
                          <template slot="selection" slot-scope="{ item }"
                            >{{ item.brand_desc }} - {{ item.model_desc }} -
                            {{ item.vehicle_board }}</template
                          >
                          <template slot="item" slot-scope="{ item }"
                            >{{ item.brand_desc }} - {{ item.model_desc }} -
                            {{ item.vehicle_board }}</template
                          >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Marca:
                        <b>{{ dataVehicle.brand_desc }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Modelo:
                        <b>{{ dataVehicle.model_desc }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Placa:
                        <b>{{ dataVehicle.vehicle_board }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Secretaria:
                        <b>{{ dataVehicle.sec_name }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Consumo:
                        <b>{{ dataVehicle.consumption_desc }}</b> - MIN.
                        <b>{{
                          dataVehicle.vehicle_average_consumption_minimum &&
                          dataVehicle.vehicle_average_consumption_minimum.toFixed(
                            2
                          )
                        }}</b>
                        - MAX.
                        <b>{{
                          dataVehicle.vehicle_average_consumption_maximum &&
                          dataVehicle.vehicle_average_consumption_maximum.toFixed(
                            2
                          )
                        }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Combustível:
                        <b>{{ dataVehicle.fuel_desc }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Data Inicial:
                        <b>{{ convertDate(filter.startDate) }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        Data Final:
                        <b>{{ convertDate(filter.endDate) }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        KM Inicial:
                        <b>{{ dataVehicle.initialKM }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        KM Final:
                        <b>{{ dataVehicle.lastKM }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        KM Percorrido:
                        <b>{{ dataVehicle.traveledKM }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Total de Litros:
                        <b>{{
                          dataVehicle.TotalLiters &&
                          dataVehicle.TotalLiters.toFixed(2)
                        }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Valor Total:
                        <b>{{ dataVehicle.TotalValue }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Abastecimentos:
                        <b>{{ dataVehicle.CountSupplies }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Média de Consumo:
                        <b>{{
                          dataVehicle.Average && dataVehicle.Average.toFixed(3)
                        }}</b>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        Situação de Consumo:
                        <b>{{ resultAverage }}</b>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="mb-6" outlined>
                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="12" sm="12">
                        <v-label><b>ABASTECIMENTOS DO VEÍCULO</b></v-label>
                      </v-col>
                      <v-col cols="12" sm="12">
                        <v-divider />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        v-for="(ds, index) in dateSupplies"
                        :key="index"
                      >
                        <v-label>
                          {{ ds.date }}
                        </v-label>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-card>
      <v-footer color="white">
        <v-btn
          color="secondary"
          class="mr-2"
          target="_blank"
          :to="`/billings/report/all/${filter.startDate}/${filter.endDate}/${filter.prefecture_id}/${filter.provider_id}/null`"
          :disabled="
            filter.provider_id && filter.startDate && filter.endDate
              ? false
              : true
          "
          block
          >CHECAR TOTAL</v-btn
        >
      </v-footer>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers";
export default {
  components: { Date },
  mixins: [Helpers],
  data: () => ({
    showSearch: false,
    search: "",
    prefectures: [],
    secretariats: [],
    vehicles: [],
    singleVehicle: {},
    dataVehicle: [],
    dataSupplies: [],
    dateSupplies: [],
    selectedSupplies: [],
    provider_id: null,
    providers: null,
    headers: [
      { text: "Data/Hora", value: "datehour", sortable: false },
      { text: "Item", value: "item_description_desc", sortable: false },
      { text: "Lts Abastecidos", value: "supply_liters_stocked" },
      { text: "Preço Licitado", value: "supply_bidding_price" },
      { text: "T. Licitado", value: "total_billing_price" },
      { text: "Preço do dia", value: "supply_price_day" },
      { text: "Total", value: "supply_value" },
      { text: "Cupom", value: "supply_coupon", sortable: false },
      { text: "Status", value: "supply_status", sortable: false },
      { text: "Corrigido", value: "supply_ajusted", sortable: false },
      { text: "Faturado", value: "supply_billed", sortable: false },
    ],
    totals: {
      bidding_total: 0,
      day_value: 0,
      billing_price: 0,
    },
    loader: false,
    resultAverage: null,
    filterSupplies: [],
    filter: {
      vehicle_id: null,
      prefecture_id: null,
      provider_id: null,
      sec_id: null,
      startDate: null,
      endDate: null,
    },
    snack: {
      show: false,
      message: "",
      color: "",
    },
  }),
  created() {
    this.Helpers;
    this.loader = true;
    this.$store.dispatch("setLoader", this.loader);
    this.$http.get(`/prefectures`).then((r) => {
      this.prefectures = r.data;
      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    });
  },
  methods: {
    getProviders() {
      this.$http
        .get(`/providers/prefecture/${this.filter.prefecture_id}`)
        .then((r) => (this.providers = r.data));
    },
    getSecretariats() {
      this.filter.vehicle_id = null;
      this.vehicles = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/distribution/secretariats/${this.filter.prefecture_id}`)
        .then((r) => {
          this.secretariats = r.data;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getVehicles() {
      if (this.filter.sec_id || this.filter.prefecture_id) {
        if (this.filter.sec_id) {
          this.loader = true;
          this.$store.dispatch("setLoader", this.loader);
          this.$http
            .get(`/distribution/vehicles/${this.filter.sec_id}`)
            .then((v) => {
              this.vehicles = v.data;
              this.loader = false;
              this.snack.color = "success";
              this.$store.dispatch("setLoader", this.loader);
            })
            .catch((e) => {
              this.loader = false;
              this.snack.show = true;
              this.snack.message = e;
              this.snack.type = "error";
              this.$store.dispatch("setLoader", this.loader);
            });
        } else if (this.filter.prefecture_id && !this.filter.sec_id) {
          this.loader = true;
          this.$store.dispatch("setLoader", this.loader);
          this.$http
            .get(
              `/distribution/vehicles/prefecture/${this.filter.prefecture_id}`
            )
            .then((v) => {
              this.vehicles = v.data;
              this.loader = false;
              this.snack.color = "success";
              this.$store.dispatch("setLoader", this.loader);
            })
            .catch((e) => {
              this.loader = false;
              this.snack.show = true;
              this.snack.message = e;
              this.snack.type = "error";
              this.$store.dispatch("setLoader", this.loader);
            });
        }
      }
    },
    getSingleVehicle() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/distribution/vehicle/${this.filter.vehicle_id}`)
        .then((v) => {
          this.singleVehicle = v.data[0];
          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getVehicleData() {
      if (this.filter.vehicle_id) {
        this.dateSupplies = [];
        this.dataVehicle = [];
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post(`/distribution/vehicle/data`, this.filter)
          .then((v) => {
            this.dataVehicle = v.data[0];
            this.dateSupplies = v.data[0].dateSupplies;
            this.resultAverage =
              v.data[0].Average < v.data[0].vehicle_average_consumption_minimum
                ? "ABAIXO DA MÉDIA"
                : v.data[0].Average >=
                    v.data[0].vehicle_average_consumption_minimum &&
                  v.data[0].Average <=
                    v.data[0].vehicle_average_consumption_maximum
                ? "NA MÉDIA"
                : "ACIMA DA MÉDIA";

            this.loader = false;
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
    getData() {
      if (this.filter.prefecture_id) {
        this.totals.day_value = 0;
        this.totals.bidding_total = 0;
        this.dataSupplies = [];
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        let liters = 0;
        let bidding_price = 0;
        let supply_price_day = 0;
        this.$http
          .post(`/distribution/econferences/data`, this.filter)
          .then((supplies) => {
            this.dataSupplies = supplies.data;
            supplies.data.map((supply, index) => {
              liters = supply.supply_liters_stocked.toFixed(3);
              bidding_price = supply.supply_bidding_price.toFixed(3);
              supply_price_day = supply.supply_price_day.toFixed(3);
              this.dataSupplies[index].supply_liters_stocked = liters;
              this.dataSupplies[index].supply_bidding_price = bidding_price;
              this.dataSupplies[index].supply_price_day = supply_price_day;
              this.totals.day_value += parseFloat(supply.supply_value);
              this.totals.bidding_total += parseFloat(
                supply.supply_bidding_value
              );
            });
            this.loader = false;
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
    checkSuppliesForVehicle() {
      const vehicle_tank_capacity = this.dataVehicle.vehicle_tank_capacity;
      const vehicle_fuel_type = this.dataVehicle.fuel_desc.trim();
      const suppliesOnCapacity = this.selectedSupplies.filter(
        (s) => s.supply_liters_stocked <= vehicle_tank_capacity
      );

      suppliesOnCapacity.map((s) => {
        console.log(s);
        if (
          (vehicle_fuel_type == "FLEX" &&
            s.item_description_desc == "GASOLINA COMUM") ||
          s.item_description_desc == "GASOLINA ADITIVADA" ||
          s.item_description_desc == "ETANOL COMUM"
        ) {
          this.filterSupplies.push(s);
        } else if (
          (vehicle_fuel_type == "GASOLINA" &&
            s.item_description_desc == "GASOLINA COMUM") ||
          s.item_description_desc == "GASOLINA ADITIVADA"
        ) {
          this.filterSupplies.push(s);
        } else if (
          vehicle_fuel_type == "ETANOL" &&
          s.item_description_desc == "ETANOL COMUM"
        ) {
          this.filterSupplies.push(s);
        } else if (
          (vehicle_fuel_type == "DIESEL" &&
            s.item_description_desc == "ÓLEO DIESEL S10") ||
          s.item_description_desc == "ÓLEO DIESEL S500"
        ) {
          this.filterSupplies.push(s);
        } else if (
          (vehicle_fuel_type == "DIESEL S10/ DIESEL COMUM" &&
            s.item_description_desc == "ÓLEO DIESEL S10") ||
          s.item_description_desc == "ÓLEO DIESEL S500"
        ) {
          this.filterSupplies.push(s);
        } else if (
          (vehicle_fuel_type == "DIESEL S10" &&
            s.item_description_desc == "ÓLEO DIESEL S10") ||
          s.item_description_desc == "ÓLEO DIESEL S500"
        ) {
          this.filterSupplies.push(s);
        } else if (
          vehicle_fuel_type == "GNV (GÁS NATURAL VEICULAR)" &&
          s.item_description_desc == "GÁS NATURAL VEICULAR"
        ) {
          this.filterSupplies.push(s);
        } else {
          this.snack.show = true;
          this.snack.message = "Tipo de combustível invalido para veículo";
          this.snack.color = "warning";
          this.filterSupplies = [];
        }
      });

      return suppliesOnCapacity;
    },
    updateSupplies() {
      console.log(this.checkSuppliesForVehicle());
      let c = confirm("Deseja desbloquear os abastecimentos selecionados?");
      if (c) {
        this.loader = true;

        if (this.checkSuppliesForVehicle().length > 0) {
          if (this.filterSupplies.length > 0) {
            this.$http
              .put("/distribution/vehicle/data", {
                supplies: this.filterSupplies,
                filter: this.filter,
              })
              .then((r) => {
                this.loader = false;
                this.snack.show = true;
                this.snack.message = r.data.result;
                this.getData();
                this.getVehicleData();
                this.snack.type = "error";
                this.selectedSupplies = [];
                this.filterSupplies = [];
                this.$store.dispatch("setLoader", this.loader);
              })
              .catch((e) => {
                this.selectedSupplies = [];
                this.filterSupplies = [];
                this.loader = false;
                this.snack.show = true;
                this.snack.message = e;
                this.snack.type = "error";
                this.$store.dispatch("setLoader", this.loader);
              });
          } else {
            this.snack.show = true;
            this.loader = false;
            this.selectedSupplies = [];
            this.filterSupplies = [];
            this.snack.message =
              "Um ou mais abastecimentos podem não entrar por ter o tipo de combustivel incompativel com o veiculo.";
            this.snack.color = "warning";
          }
        } else {
          this.loader = false;
          this.snack.show = true;
          this.selectedSupplies = [];
          this.filterSupplies = [];
          this.snack.message =
            "Abastecimento maior que a capacidade do tanque do veículo.";
          this.snack.color = "warning";
        }
      }
    },
  },
};
</script>

<style>
</style>